import { useEffect, useState } from "react";
import { Shuffle } from "lucide-react";
import { api } from "@/lib/api";
import { EpisodeCard } from "@/components/EpisodeCard";
import { Skeleton } from "@/components/ui/skeleton";
import { useSettings } from "@/context/SettingsContext";

export const RandomPick = () => {
  const [episodes, setEpisodes] = useState(null);
  const [loading, setLoading] = useState(true);
  const { homepage } = useSettings();

  const load = () => {
    setLoading(true);
    api.get("/episodes/picks").then((r) => setEpisodes(r.data)).catch(() => setEpisodes([])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  if (homepage.pick_enabled === false || (!loading && !episodes?.length)) return null;
  return (
    <section id="pick" className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-16" data-testid="random-pick-section">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          {homepage.pick_eyebrow && <p className="eyebrow mb-2">{homepage.pick_eyebrow}</p>}
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="random-pick-title">{homepage.pick_title || "Try These First"}</h2>
        </div>
        <button onClick={load} disabled={loading} className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm font-semibold text-slate-200 hover:bg-white/10 hover:text-white transition-colors disabled:opacity-50" data-testid="random-pick-shuffle">
          <Shuffle size={15} className={loading ? "animate-spin" : ""} /> Other Great Options
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 min-w-0" data-testid="random-pick-grid">
        {loading && !episodes
          ? [...Array(3)].map((_, i) => <Skeleton key={i} className="h-36 rounded-2xl bg-white/5" />)
          : episodes.map((ep, i) => <EpisodeCard key={ep.id} episode={ep} index={i + 1} />)}
      </div>
    </section>
  );
};
